import React, { useEffect } from 'react';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import SearchHeroSection from '../components/CollegeFinder/SearchHeroSection';
import JobSearchResults from '../components/Jobs/JobSearchResults';
// Reusing these sections as requested
import CounselorSection from '../components/CollegeFinder/CounselorSection';
import NewsUpdates from '../components/CollegeFinder/NewsUpdates';
import './CollegeFinder.css'; // Reusing page level styles if they are generic enough (background etc)

const JobsPage = () => {
    
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="college-finder-page">
      <Navbar />
      
      {/* Hero Section - forcing isSearchMode={true} to get the small "after search" look */}
      <SearchHeroSection isSearchMode={true} />
      
      <JobSearchResults />
      
      {/* "we have our find our right counsellor section in this page" */}
      <CounselorSection />

      {/* "also we have our latest news and exam page here" */}
      <NewsUpdates />
      
      <Footer />
    </div>
  );
};

export default JobsPage;
